// src/directives/tableHeaderDrag.js

// 定义命名函数，方便后续移除监听
const handleMouseMove = (e, bodyWrapper, startX, startScrollLeft) => {
  const dx = e.clientX - startX;
  bodyWrapper.scrollLeft = startScrollLeft - dx;
};

const handleMouseUp = (removeListeners) => {
  removeListeners();
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
};

export default {
  bind(el) {
    const headerWrapper = el.querySelector('.el-table__header-wrapper');
    const bodyWrapper = el.querySelector('.el-table__body-wrapper');
    
    if (!headerWrapper || !bodyWrapper) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    
    // 存储移除监听器的函数，用于 unbind
    let removeGlobalListeners = null;

    const onMouseDown = (e) => {
      // 1. 排除干扰元素：排序、筛选、列宽拖拽
      if (
        e.target.closest('.el-table__sort-caret') || 
        e.target.closest('.el-table__filter-trigger') ||
        e.target.closest('.el-table__column-resize-handle')
      ) {
        return;
      }

      isDown = true;
      startX = e.clientX;
      startScrollLeft = bodyWrapper.scrollLeft;
      
      // 视觉反馈
      document.body.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';

      // 定义具体的移动逻辑
      const onMove = (moveEvent) => {
        if (!isDown) return;
        const dx = moveEvent.clientX - startX;
        bodyWrapper.scrollLeft = startScrollLeft - dx;
      };

      // 定义结束逻辑
      const onEnd = () => {
        isDown = false;
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        
        // 移除全局监听
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('mouseleave', onEnd);
      };

      // 绑定全局监听
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('mouseleave', onEnd);
      
      // 保存移除函数供 unbind 使用（以防组件销毁时鼠标仍按下）
      removeGlobalListeners = onEnd;
    };

    // 绑定局部监听
    headerWrapper.addEventListener('mousedown', onMouseDown);
    
    // 将移除函数挂载到元素上，供 unbind 调用
    el._dragCleanup = () => {
      headerWrapper.removeEventListener('mousedown', onMouseDown);
      if (removeGlobalListeners) removeGlobalListeners();
    };
  },

  unbind(el) {
    // 关键：清理所有监听器，防止内存泄漏
    if (el._dragCleanup) {
      el._dragCleanup();
    }
  }
};


// WEBPACK FOOTER //
// ./src/utils/tableDragScroll.js